import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PrivateRoute = ({ children, requireAdmin = false, requireClient = false, requireAgent = false }) => {
  const { user, loading, isAdmin, isAdminOrStaff, isClient } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#41B649] mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If admin access required, allow both admin AND staff users
  if (requireAdmin && !isAdminOrStaff) {
    return <Navigate to="/" replace />;
  }

  // If agent access required but user is not agent
  if (requireAgent && user?.role !== 'agent') {
    return <Navigate to="/" replace />;
  }

  // If client access required but user is not client, redirect to home
  if (requireClient && !isClient) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and authorized, render the children
  return children;
};
